const ENCRYPT_XOR1 = 0xa5;
const ENCRYPT_XOR2 = 0x2b;
const ENCRYPT_XOR3 = 0x5a;

export function cheapDecrypt(input: Uint8Array): string {
    const inputArray = new Uint8Array(input);

    // Very Cheap encryption
    for (let i = 0; i < inputArray.length; i++) {
        inputArray[i] ^= ENCRYPT_XOR3;

        // Rotate 20+
        if (inputArray[i] > 235) {
            inputArray[i] = inputArray[i] - 236;
        } else {
            inputArray[i] += 20;
        }

        inputArray[i] ^= ENCRYPT_XOR2;

        // Rotate 20+
        if (inputArray[i] > 235) {
            inputArray[i] = inputArray[i] - 236;
        } else {
            inputArray[i] += 20;
        }

        inputArray[i] ^= ENCRYPT_XOR1;
    }

    return new TextDecoder().decode(inputArray.filter((x) => x !== 0)).trim();
}

export function cheapEncryptPassToBase64(input: string): string {
    input = input.toUpperCase();
    const bytes = Array(20).fill('z'.charCodeAt(0)) as number[];
    for (let i = 0; i < Math.min(20, input.length); i++) {
        bytes[i] = input.charCodeAt(i);
    }

    for (let i = 0; i < bytes.length; i++) {
        const diff = bytes[i] - 20 - i;
        bytes[i] = diff;
    }

    return btoa(String.fromCharCode(...bytes));
}